<template>
  <div>
    <div class="display-2" align-center>Du musst dich verlaufen haben. Hier ist nichts</div>
    
  </div>
</template>

<script>
  export default {
    data: () => ({

    })
  }
</script>

